import {
  getDateTimeTextKor,
  getDayText,
  getMonthDateDayKor,
  getYearMonthDate,
  getYearMonthDate2,
} from '../calendar';
import * as xlsx from 'xlsx-js-style';
import { uniq } from 'lodash-es';
import { reqCustomerAddresses } from './api';
import { getPdfMake } from '../util/pdfmakeHelper';
import * as logoImage from '../logo_small.png';

const presentEstimateQty = (schedule) => {
  /* return schedule.manualCheckout === 1 ? 
		schedule.orderQty : 
		(schedule.estimateQty !== 0 ? schedule.estimateQty : schedule.orderQty); */
  return schedule.estimateQty;
};

/*
	OrderCalendar에서 사용하는 orders의 data structure. 
	[{
		customerId-serviceTime, customerId, customerName, serviceTime, deliveryGroup
		menu: [{ 
			date, supplierName, menuName, pickupTime, orderQty, 
		}]
	}]
 */

// schedules response data를 orders로 변환
export function handleSchedulesResult(data) {
  const orders = [];

  data.forEach((item) => {
    let found = orders.find(
      (order) =>
        order['customerId-serviceTime'] ===
        `${item.customerId}-${item.serviceTime}`
    );

    if (!found) {
      found = {};
      found[
        'customerId-serviceTime'
      ] = `${item.customerId}-${item.serviceTime}`;
      found['customerId'] = item.customerId;
      found['customerName'] = item.customer?.name;
      found['serviceTime'] = item.serviceTime;
      found['deliveryGroup'] = item.customer?.deliveryGroup?.desc ?? null;
      found['menu'] = [];
      orders.push(found);
    }

    found.menu.push({
      id: item.id,
      published: item.published,
      lock: false,
      date: item.date,
      supplierId: item.supplier?.id ?? null,
      supplierName: item.supplier?.name ?? null,
      menuType: item.menuType,
      menuId: item.menuId,
      menuName: item.menu?.name ?? null,
      menuCategory: item.menu?.menuCategory ?? [],
      serviceType: item.supplier?.serviceType ?? [],
      subMenu: item.subMenu ?? [],
      pickupTime: item.pickupTime,
      orderQty: item.orderQty ?? 0,
      estimateQty: presentEstimateQty(item),
      manualCheckout: !!item.manualCheckout,
      memo: item.memo ?? null,
    });
  });

  sortOrdersByDeliveryGroup(orders);

  return orders;
}

// curations response data를 orders로 변환
export function handleSuggestionsResult(data) {
  const orders = [];

  data.forEach((suggestion) => {
    suggestion.menu.forEach((menu) => {
      let found = orders.find(
        (order) =>
          order['customerId-serviceTime'] ===
          `${menu.customerId}-${menu.serviceTime}`
      );

      if (!found) {
        found = {};
        found[
          'customerId-serviceTime'
        ] = `${menu.customerId}-${menu.serviceTime}`;
        found['customerId'] = suggestion.customerId;
        found['customerName'] = suggestion.customerName;
        found['serviceTime'] = menu.serviceTime;
        found['deliveryGroup'] = suggestion.deliveryGroup;
        found['menu'] = [];
        orders.push(found);
      }

      found.menu.push({
        published: false,
        lock: false,
        date: menu.date.replace(/-/g, ''), // YYYY-MM-DD => YYYYMMDD
        supplierId: menu.supplierId,
        supplierName: menu.supplierName,
        menuType: menu.menuType,
        menuId: menu.menuId,
        menuName: menu.menuName,
        menuCategory: menu.menuCategory ?? [],
        serviceType: menu.serviceType,
        subMenu: menu.subMenu ?? [],
        pickupTime: menu.pickupTime,
        orderQty: menu.orderQty ?? 0,
        memo: null,
      });
    });
  });

  sortOrdersByDeliveryGroup(orders);

  return orders;
}

// deliveryGroup으로 정렬
export function sortOrdersByDeliveryGroup(orders) {
  orders.sort((a, b) => {
    if (a.serviceTime === b.serviceTime) {
      // service time 같은 경우
      if (a.deliveryGroup === b.deliveryGroup) {
        return a.customerName < b.customerName ? -1 : 1;
      } else if (
        (a.deliveryGroup === null || a.deliveryGroup === '없음') &&
        b.deliveryGroup !== null &&
        b.deliveryGroup !== '없음'
      ) {
        return 1;
      } else if (
        (b.deliveryGroup === null || b.deliveryGroup === '없음') &&
        a.deliveryGroup !== null &&
        a.deliveryGroup !== '없음'
      ) {
        return -1;
      } else if (
        (a.deliveryGroup === null || a.deliveryGroup === '없음') &&
        (b.deliveryGroup === null || b.deliveryGroup === '없음')
      ) {
        return a.customerName < b.customerName ? -1 : 1;
      } else {
        return a.deliveryGroup < b.deliveryGroup ? -1 : 1;
      }
    } else {
      return a.serviceTime < b.serviceTime ? -1 : 1;
    }
  });
}

const MENUS_TO_EXCLUDE = ['안먹을래요', '미선택'];

const SERVICE_TYPE_PB = 47; // 임시조치

// 주어진 날의 메뉴 반환
export function findOrderOfDay(customerOrders, day) {
  const dayString = getYearMonthDate(day);
  const orders = customerOrders.menu
    .filter((menu) => menu.date.startsWith(dayString) && menu.menuType !== '2')
    .filter((menu) => MENUS_TO_EXCLUDE.indexOf(menu.menuName) < 0)
    .sort((a, b) => {
      const aIsPb = a.serviceType[0]?.id === SERVICE_TYPE_PB;
      const bIsPb = b.serviceType[0]?.id === SERVICE_TYPE_PB;
      const aIsProduct = a.menuType === '3';
      const bIsProduct = b.menuType === '3';
      if (aIsPb && bIsPb) return 0;
      else if (aIsPb || bIsPb) return aIsPb ? 1 : -1;
      else if (aIsProduct && bIsProduct) return 0;
      else if (aIsProduct || bIsProduct) return aIsProduct ? 1 : -1;
      else {
        if (a.pickupTime != b.pickupTime) {
          return a.pickupTime < b.pickupTime ? -1 : 1;
        }
        return 0;
      }
    });
  // 배제 메뉴 화면 표시 요청
  const excluded = customerOrders.menu
    .filter(
      (menu) =>
        menu.date.startsWith(dayString) &&
        MENUS_TO_EXCLUDE.indexOf(menu.menuName) >= 0
    )
    .map((menu) => {
      menu.showTextOnly = true;
      return menu;
    });
  return excluded.length > 0 ? orders.concat(excluded) : orders;
}

// 주어진 날 주문 개수
export function getDayOrdersCount(orders, day) {
  let count = 0;
  const dayString = getYearMonthDate(day);
  orders.forEach((o) => {
    o.menu.forEach((m) => {
      if (m.date === dayString && (m.orderQty ?? 0) > 0) {
        count += m.orderQty;
      }
    });
  });

  return count;
}

// 'a' ~ 'z' color values
const DELIVERY_GROUP_COLORS = [
  '#cfe2f3',
  '#fff2cc',
  '#fdd4bd',
  '#abb2d6',
  '#ffcff3',
  '#ffbf88',
  '#abd673',
  '#abd673',
  '#ffcfe2',
  '#fff895',
  '#c2ffc1',
  '#ffc0c0',
  '#b7c8ff',
  '#ffc1f2',
  '#e4a2ff',
  '#c6ffb7',
  '#7effef',
  '#6fb9ff',
  '#bad4ff',
  '#ecb5ff',
  '#a3eaff',
  '#ffba93',
  '#c6d1ff',
  '#ffc1ca',
  '#9aff54',
  '#94e6ff',
];

// A-Z 해당 컬러값(hexacode) 제공
export function getDeliveryGroupColor(code) {
  if (!code || code === '없음') return '#ffffff';

  const idx = code.toLowerCase().charCodeAt(0) - 'a'.charCodeAt(0);
  return DELIVERY_GROUP_COLORS[
    Math.min(DELIVERY_GROUP_COLORS.length - 1, Math.max(0, idx))
  ];
}

export function getServiceTimeText(serviceTime) {
  switch (serviceTime) {
    case '0':
      return '조';
    case '1':
      return '중';
    case '2':
      return '석';
    default:
      return '?';
  }
}

/**
 *
 * @param {*} orders weekly orders
 * @param {*} day
 */
export const downloadDailyDeliverySpecs = async (orders, day) => {
  // collect schedules for the day
  const dayString = getYearMonthDate(day);
  const dailySchedules = [];
  orders.forEach((o) => {
    const menus = o.menu.filter(
      (m) => m.date === dayString && (m.orderQty ?? 0) > 0
    );
    if (menus.length > 0) {
      const { menu, ...fields } = o;
      menus.forEach((m) => {
        dailySchedules.push({
          ...fields,
          menu: m,
        });
      });
    }
  });

  // collect customers
  const customers = uniq(dailySchedules.map((el) => el.customerId));
  const { data } = await reqCustomerAddresses(customers);

  // sorting TODO
  // console.log(dailySchedules)

  // conv to sheet
  const dayText = getDayText(day, false);
  const dateText = getYearMonthDate2(day);

  const header = {
    day: '요일',
    date: '날짜',
    customer: '고객사',
    supplier: '공급처',
    menu: '메인메뉴',
    customerAddress: '고객사주소',
    bags: '가방수',
    qty: '인분수',
    bagType: '가방유형',
  };

  // NOTE: width 단순 pixel 값 아님. (엑셀에서 직접 확인한 값 적용)
  const cols = [
    { width: 8 },
    { width: 12 },
    { width: 25 },
    { width: 25 },
    { width: 40 },
    { width: 65 },
    { width: 8 },
    { width: 8 },
    { width: 12 },
  ];

  const sheetJson = dailySchedules.map((el) => {
    const capacity = 10; // 큰 가방 기준
    return {
      day: dayText,
      date: dateText,
      customer: el.customerName,
      supplier: el.menu.supplierName,
      menu: el.menu.menuName,
      customerAddress: getAddress(data, el.customerId),
      bags: Math.ceil(el.menu.orderQty / capacity),
      qty: el.menu.orderQty,
      bagType: '큰가방',
    };
  });

  sheetJson.splice(0, 0, header);

  let ws = xlsx.utils.json_to_sheet(sheetJson, { skipHeader: true });
  ws['!cols'] = cols;
  let wb = xlsx.utils.book_new();

  xlsx.utils.book_append_sheet(wb, ws, '배송명찰');
  xlsx.writeFile(wb, `${dateText}-배송명찰.xlsx`);
};

const getAddress = (customers, id) => {
  const found = customers.find((el) => el.id === id);
  return found?.address ?? 'N/A';
};

export const downloadDailyCookOrders = async (schedules, day) => {
  /*
		suppliers: [ { ...supplier, orders, } ]
	*/
  const dayString = getYearMonthDate(day);
  const suppliers = [];
  schedules
    .filter((s) => s.orderQty > 0 && s.date === dayString) // collect schedules for the day
    .forEach((s) => {
      // group orders by a supplier
      const { supplier, ...order } = s;
      let found = suppliers.find((el) => el.id === supplier.id);
      if (!found) {
        found = { ...supplier };
        found.orders = [];
        suppliers.push(found);
      }
      found.orders.push(order);
    });

  // aggregate & sort
  const aggregated = suppliers.map((s) => {
    // aggregate
    const summary = [];
    s.orders.forEach((o) => {
      let found = summary.find((el) => el.id === o.menuId);
      if (!found) {
        found = {
          ...o.menu,
          subMenu: o.subMenu.map((sm) => sm.name).join('/'), // 현재는 메뉴 별로 subMenu 차이 안 생김
          amount: 0,
        };
        summary.push(found);
      }
      found.amount += o.orderQty;
    });

    // sort
    s.orders.sort((a, b) => {
      if (a.pickupTime === b.pickupTime) {
        if (a.customer.id === b.customer.id) {
          return 0;
        } else {
          return a.customer.name < b.customer.name ? -1 : 1;
        }
      }
      return a.pickupTime < b.pickupTime ? -1 : 1;
    });

    return Object.assign(s, {
      summary,
    });
  });

  // console.log(aggregated)

  // convert to pdf data
  const orderDateText = getMonthDateDayKor(day);
  const printDateText = getDateTimeTextKor(new Date());

  const content = [];
  aggregated.forEach((el, idx) => {
    /// heading

    const logo = {
      width: 80,
      // image: logoImage
      text: '주식회사 푸딩',
    };
    const title = {
      width: '*',
      style: 'header',
      text: `${orderDateText}  주문 체크리스트`,
    };
    const header = {
      alignment: 'justify',
      columns: [logo, title, { width: 'auto', text: '' }],
    };
    if (idx > 0) {
      header.pageBreak = 'before';
    }
    content.push(header);

    /// metadata

    const metadataTable = {
      alignment: 'left',
      table: {
        widths: [80, 'auto'],
        body: [
          [
            { style: 'metaCellHeader', text: '파트너' },
            { style: 'metaCellLarge', text: el.name },
          ],
          [
            { style: 'metaCellHeader', text: '주문날짜' },
            { style: 'metaCellLarge', text: orderDateText },
          ],
          [
            { style: 'metaCellHeader', text: '출력일시' },
            { style: 'metaCellSmall', text: printDateText },
          ],
        ],
      },
    };
    const notice = {
      alignment: 'right',
      fontSize: 13,
      text: '"고객사별 수저, 젓가락을\n한번 더 확인해 주세요."',
    };
    content.push({
      margin: [0, 16, 0, 0],
      alignment: 'justify',
      columns: [metadataTable, notice],
    });

    /// 당일 주문 합계

    const aggregatedOrderTable = {
      margin: [0, 6, 0, 0],
      table: {
        headerRows: 1,
        widths: ['auto', '*', 80],
        body: [
          [
            { style: 'orderCellHeader', fillColor: '#eeeeee', text: '메뉴명' },
            {
              style: 'orderCellHeader',
              fillColor: '#eeeeee',
              text: '상세 메뉴',
            },
            {
              style: 'orderCellHeader',
              fillColor: '#eeeeee',
              text: '합계 수량',
            },
          ],
        ],
      },
    };
    el.summary.forEach((s) => {
      aggregatedOrderTable.table.body.push([
        { style: 'orderContent', text: s.name },
        { style: 'orderContent', text: s.subMenu },
        { style: 'orderContent', text: s.amount },
      ]);
    });
    content.push({
      style: 'subHeader',
      text: '당일 주문 합계',
    });
    content.push(aggregatedOrderTable);

    /// 배송 세부 내역

    const ordersTable = {
      margin: [0, 6, 0, 0],
      table: {
        headerRows: 1,
        widths: [80, '*', 'auto', 80, 85],
        body: [
          [
            {
              style: 'orderCellHeader',
              fillColor: '#eeeeee',
              text: '픽업시간',
            },
            { style: 'orderCellHeader', fillColor: '#eeeeee', text: '메뉴명' },
            { style: 'orderCellHeader', fillColor: '#eeeeee', text: '고객사' },
            { style: 'orderCellHeader', fillColor: '#eeeeee', text: '수량' },
            {
              style: 'orderCellHeader',
              fillColor: '#eeeeee',
              text: '패키징 완료',
            },
          ],
        ],
      },
    };
    el.orders.forEach((o) => {
      const pickupTime = o.pickupTime.slice(0, 2) + ':' + o.pickupTime.slice(2);
      ordersTable.table.body.push([
        { style: 'orderContent', text: pickupTime },
        { style: 'orderContent', text: o.menu.name },
        { style: 'orderContent', text: o.customer.name },
        { style: 'orderContent', text: o.orderQty },
        { style: 'orderContent', text: '' },
      ]);
    });
    content.push({
      style: 'subHeader',
      text: '배송 세부 내역',
    });
    content.push(ordersTable);

    /// 서명
    const agreement = {
      margin: [0, 14, 0, 0],
      alignment: 'center',
      fontSize: 10,
      text: [
        '푸딩 위생 체크리스트 내 1. 영업자 준수사항 관리, 2. 영업자 및 종사자 위생 관리, ',
        '3. 원료 관리, 4. 식품제조 항목을 준수한 청결한 주방 환경에서 조리된 음식입니다.',
        '			(서명)',
      ],
    };
    const signPlaceholder = {
      margin: [0, 6, 0, 0],
      alignment: 'right',
      fontSize: 10,
      text: '담당자                                                (서명)',
    };
    content.push(agreement);
    // content.push(signPlaceholder);
  });

  const docDef = {
    info: {
      title: `${orderDateText} 조리주문 체크리스트`,
    },
    pageSize: 'A4',
    pageOrientation: 'landscape',
    pageMargins: [40, 20, 40, 30],
    defaultStyle: {
      font: 'NotoSansKr',
    },
    styles: {
      header: {
        alignment: 'center',
        fontSize: 22,
        bold: true,
      },
      subHeader: {
        margin: [0, 14, 0, 0],
        fontSize: 15,
        bold: true,
      },
      metaCellHeader: {
        alignment: 'center',
        fontSize: 10,
      },
      metaCellLarge: {
        alignment: 'center',
        fontSize: 12,
      },
      metaCellSmall: {
        alignment: 'center',
        margin: [3, 4],
        fontSize: 8,
      },
      orderCellHeader: {
        alignment: 'center',
        fontSize: 12,
      },
      orderContent: {
        alignment: 'center',
        margin: [3, 5],
        fontSize: 14,
      },
    },
    content,
  };

  try {
    const pdfDoc = getPdfMake().createPdf(docDef);
    pdfDoc.download(`fooding-orders-${orderDateText}.pdf`);
  } catch (err) {
    console.trace(err);
    throw err;
  }
};
